import React from 'react';
import { Target, Zap, Shield, TrendingUp, DollarSign, Sprout } from 'lucide-react';
import { motion } from 'framer-motion';
const BENEFITS = [{
  icon: Target,
  title: 'Claridad Total',
  description: 'Sabés qué hacer y cuándo. Sin adivinar, sin improvisar.'
}, {
  icon: Shield,
  title: 'Control Real',
  description: 'Tu huerta deja de depender del azar, el clima o la suerte.'
}, {
  icon: TrendingUp,
  title: 'Continuidad',
  description: 'Cosechás de forma estable, sin cortes ni abandonos.'
}, {
  icon: Zap,
  title: 'Seguridad',
  description: 'Menos errores, menos pérdidas, más confianza en cada paso.'
}, {
  icon: Sprout,
  title: 'Independencia',
  description: 'Menos dependencia del súper. Más control sobre tu alimentación.'
}, {
  icon: DollarSign,
  title: 'Posibilidad de Ingreso',
  description: 'Si elegís emprender, tenés la base para monetizar tu huerta.'
}];
export function BenefitsSection() {
  return <section className="py-24 px-4 bg-zinc-950" data-id="element-1">
      <div className="max-w-6xl mx-auto" data-id="element-2">
        <div className="text-center mb-16" data-id="element-3">
          <h2 className="text-3xl md:text-5xl font-bold text-white mb-6" data-id="element-4">
            Qué Va a Cambiar en Vos
          </h2>
          <p className="text-gray-400 max-w-2xl mx-auto text-lg" data-id="element-5">
            Esto no es "aprender a plantar". Esto es pasar a:
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-6">
          {BENEFITS.map((benefit, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-zinc-900/50 border border-zinc-800 p-8 rounded-xl hover:bg-zinc-900 transition-colors group" data-id="element-7">
              <div className="bg-green-500/10 w-12 h-12 rounded-lg flex items-center justify-center mb-6 group-hover:bg-green-500/20 transition-colors" data-id="element-8">
                <benefit.icon className="w-6 h-6 text-green-500" data-id="element-9" />
              </div>
              <h3 className="text-xl font-bold text-white mb-3" data-id="element-10">
                {benefit.title}
              </h3>
              <p className="text-gray-400 leading-relaxed" data-id="element-11">
                {benefit.description}
              </p>
            </motion.div>)}
        </div>

        <div className="mt-16 text-center" data-id="element-12">
          <div className="inline-block bg-zinc-900 border border-zinc-800 rounded-full px-8 py-4" data-id="element-13">
            <p className="text-lg font-medium text-gray-300" data-id="element-14">
              "Esto no es motivación. Es{' '}
              <span className="text-green-500 font-bold" data-id="element-15">um sistema.</span>"
            </p>
          </div>
        </div>
      </div>
    </section>;
}